module.exports = __webpack_public_path__ + "img/53.2a637212.jpg";